import { render } from "./AposBreadcrumbSwitch.vue?vue&type=template&id=2bd588ee&scoped=true"
import script from "./AposBreadcrumbSwitch.vue?vue&type=script&lang=js"
export * from "./AposBreadcrumbSwitch.vue?vue&type=script&lang=js"

import "./AposBreadcrumbSwitch.vue?vue&type=style&index=0&id=2bd588ee&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd588ee"],['__file',"area/ui/apos/components/AposBreadcrumbSwitch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bd588ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bd588ee', __exports__)) {
    api.reload('2bd588ee', __exports__)
  }
  
  module.hot.accept("./AposBreadcrumbSwitch.vue?vue&type=template&id=2bd588ee&scoped=true", () => {
    api.rerender('2bd588ee', render)
  })

}


export default __exports__